<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">客户端问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">设置</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>麦克风没有声音怎么办？
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />答案：多登录几次客户端或者重新下载，具体请看教学视频：<a target="_blank" href="https://www.bilibili.com/video/BV1k54y1o7ov/?vd_source=d0078719a57688f7b91b5e74df1240e5">【海星云教程】云电脑怎么开麦？有电流声怎么办？声音卡顿怎么办？我来教你解决呀_新手教程</a>
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>出现游戏节点错误怎么办?
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />请检查网络，关闭防火墙，重启路由器
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>画面不清晰怎么办?
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />请按照各自网络调整
              <br />
              <img src="../../../../static/plem17.png" alt />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Client')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.title {
  font-weight: 900;
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/khd/Pro_String.vue